import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot } from "vue";
import { useCsrfStore } from "@/stores/csrf";
import { onMounted } from "vue";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { initCsrfToken } = useCsrfStore();
        onMounted(initCsrfToken);
        return (_ctx, _cache) => {
            return _renderSlot(_ctx.$slots, "default");
        };
    }
});
